<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col>
					<b-form-select
						v-model="departmentId"
						name="departmentId"
					>
						<option v-for="(selectOption, indexOpt) in departments"
								:key="indexOpt"
								:value="selectOption.id">{{ selectOption.name }}
						</option>
						<template slot="first">
							<option :value="null" disabled>
								-- {{ $t('priceControl.departments') }} --
							</option>
						</template>
					</b-form-select>
				</b-col>
				<b-col>
					<date-picker
						v-model="fromDate"
						lang="ru"
						style="width: 100%"
						:placeholder="$t('certificate.fromDate')"
						valueType="format"
						format="DD-MM-YYYY"/>
				</b-col>
				<b-col>
					<date-picker
						v-model="toDate"
						lang="ru"
						style="width: 100%"
						:placeholder="$t('certificate.toDate')"
						value-type="format"
						format="DD-MM-YYYY"/>
				</b-col>
				<b-col cols="2">
					<b-button @click="getItems" variant="dark" class="fa fa-search mr-3"/>
					<b-button @click="print" variant="outline-dark" class="fa fa-print"/>
				</b-col>
			</b-row>
			<hr class="mt-4">
		</div>
		<b-card-body>
			<b-row>
				<b-col cols="3">
					<div style="font-size: 12px">Central Asia Megastar</div>
				</b-col>
				<b-col cols="6" class="text-center">
					<h6><b>Товарооборот за период с {{ fromDate ? fromDate : '________' }} по {{ toDate ? toDate : '________' }}</b></h6>
				</b-col>
				<b-col class="text-right"></b-col>
			</b-row>
			<b-row>
				<b-col>
					<b style="font-size: 12px">{{ $t('pricing.department') }}: {{ departmentId ? depName : '__________________' }}</b>
				</b-col>
			</b-row>
			<b-row class="mt-5 mb-4">
				<b-col>
					<table class="b-table table-hover table-striped table-bordered" style="font-size: 11px; width: 100%">
						<thead>
						<tr>
							<th colspan="4"></th>
							<th class="text-center" style="font-size: 10px" colspan="2">Сальдо на начало</th>
							<th class="text-center" style="font-size: 10px" colspan="2">Приходы за период</th>
							<th class="text-center" style="font-size: 10px" colspan="2">Продажи за период</th>
							<th class="text-center" style="font-size: 10px" colspan="2">Переоценки</th>
							<th class="text-center" style="font-size: 10px" colspan="2">Прочие расходы</th>
							<th class="text-center" style="font-size: 10px" colspan="2">Сальдо на конец</th>
						</tr>
						<tr>
							<th class="text-center" style="font-size: 10px">№</th>
							<th style="font-size: 10px">{{ $t('Наименование') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('goods.special-barcode') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('incomes.create.price') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('sale.kol-vo') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('pos.sum') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('sale.kol-vo') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('pos.sum') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('sale.kol-vo') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('pos.sum') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('sale.kol-vo') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('pos.sum') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('sale.kol-vo') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('pos.sum') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('sale.kol-vo') }}</th>
							<th class="text-center" style="font-size: 10px">{{ $t('pos.sum') }}</th>
						</tr>
						</thead>
						<tbody v-if="!loading">
						<tr v-for="(item, index) in items" :key="`report3-${index}`">
							<td class="text-center">{{ index + 1 }}</td>
							<td class="text-left">{{ item.itemName }}</td>
							<td class="text-center">{{ item.barcode }}</td>
							<td class="text-center">{{ item.price }}</td>
							<td class="text-center">{{ item.bremaining }}</td>
							<td class="text-center">{{ item.bsumma }}</td>
							<td class="text-center">{{ item.wcount }}</td>
							<td class="text-center">{{ item.wsumma }}</td>
							<td class="text-center">{{ item.sCount }}</td>
							<td class="text-center">{{ item.ssumma }}</td>
							<td class="text-center">{{ item.premaining }}</td>
							<td class="text-center">{{ item.psumma }}</td>
							<td class="text-center">{{ item.spcount }}</td>
							<td class="text-center">{{ item.spsumma }}</td>
							<td class="text-center">{{ item.blremaining }}</td>
							<td class="text-center">{{ item.blsumma }}</td>
						</tr>
						</tbody>
						<tbody v-else>
						<tr>
							<td class="text-center" colspan="16">
								<b-spinner small class="mr-2"/><strong>Loading...</strong>
							</td>
						</tr>
						</tbody>
					</table>
				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import UsersService from "../../../services/users.sevice";
import {TokenService} from "../../../services/storage.service";
import ReportService from "./report.service";

export default {
	name: "Товарооборот за период",
	components: {Multiselect},
	data() {
		return {
			items: {},
			fromDate: null,
			toDate: null,
			departments: [],
			departmentId: null,
			departmentName: '',
			loading: false
		};
	},
	computed: {
		depName() {
			this.departments.forEach(dep => {
				if (dep.id === this.departmentId) {
					this.departmentName = dep.name
				}
			})
			return this.departmentName
		},
		incomesInTermEur() {
			let sum = 0
			this.items.incomesInTerm.forEach(t => {
				sum += t.sumInEur
			})
			return sum
		},
		incomesInTermUzs() {
			let sum = 0
			this.items.incomesInTerm.forEach(t => {
				sum += t.sumInUzs
			})
			return sum
		},
		offsInTermEur() {
			let sum = 0
			this.items.offsInTerm.forEach(t => {
				sum += t.sumInEur
			})
			return sum
		},
		offsInTermUzs() {
			let sum = 0
			this.items.offsInTerm.forEach(t => {
				sum += t.sumInUzs
			})
			return sum
		}
	},
	methods: {
		print() {
			window.print();
		},
		async getDeps() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
			})
		},
		getItems() {
			this.loading = true
			if (this.fromDate && this.toDate && this.departmentId) {
				let data = {
					startDate: this.fromDate,
					endDate: this.toDate,
					departmentId: this.departmentId
				}
				ReportService.getReportItems3(data).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		}
	},
	created() {
		this.getDeps();
	},
	watch: {}
}
</script>

<style scoped lang="scss">

@page  {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}
	.nav {
		display: none;
	}
	.nav-pills {
		display: none;
	}
	.flex-column {
		display: none;
	}
}

</style>
